import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Route, Router, Routes } from '@angular/router';
import { BaseApiService } from '../_base-http/base-api.service';
import { MasterComponent } from '../_layout/master/master.component';
import { NavigationItem } from '../_models/navigation-item';
import {
  CODE_PAGE_CAU_HOI_THUONG_GAP,
  CODE_PAGE_CONG_CU_DAU_TU,
  CODE_PAGE_DOI_NGU_LANH_DAO,
  CODE_PAGE_DOI_TAC_CUA_CHUNG_TOI,
  CODE_PAGE_GIOI_THIEU,
  CODE_PAGE_GOC_NHIN_DAU_TU,
  CODE_PAGE_KIEN_THUC_CO_BAN,
  CODE_PAGE_KIEN_THUC_DAU_TU,
  CODE_PAGE_LIEN_HE,
  CODE_PAGE_QUAN_HE_CO_DONG,
  CODE_PAGE_QUAN_LY_DANH_MUC_DAU_TU,
  CODE_PAGE_QUYEN_MIEN_TRU,
  CODE_PAGE_SU_KIEN,
  CODE_PAGE_THONG_CAO_BAO_CHI,
  CODE_PAGE_TIN_TUC,
  CODE_PAGE_TRANG_CHU,
  CODE_PAGE_TRIET_LY_DAU_TU,
  CODE_PAGE_TRUYEN_THONG,
  CODE_PAGE_TU_VAN_DAU_TU,
  CODE_PAGE_VE_CHUNG_TOI,
} from '../_models/predefined-code-list';
import { CategoryService } from './category.service';
import { NavigationService } from './navigation.service';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class RouteCustomService extends BaseApiService {
  constructor(
    private _http: HttpClient,
    private _stateService: StateService,
  ) {
    super(_http, _stateService);
  }

  genRoute(navItem: NavigationItem, parentSlug?: string, parentNav?: NavigationItem): Route | undefined {
    switch (navItem.code) {
      case CODE_PAGE_TRANG_CHU:
        return {
          path: navItem.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () => import('./../../pages/home/home.module').then((m) => m.HomeModule),
            },
          ],
          data: { title: navItem.name, navItem },
        };

      case CODE_PAGE_VE_CHUNG_TOI:
        return {
          path: navItem.linkUrl,
          data: { title: navItem.name, navItem },
        };

      case CODE_PAGE_GIOI_THIEU:
        return {
          path: navItem.linkUrl,
          loadChildren: () => import('./../../pages/about-us/overview/overview.module').then((m) => m.OverviewModule),
          data: { title: navItem.name, subNav: navItem },
        };

      case CODE_PAGE_TRIET_LY_DAU_TU:
        return {
          path: navItem.linkUrl,
          loadChildren: () => import('./../../pages/about-us/philosophy/philosophy.module').then((m) => m.PhilosophyModule),
          data: { title: navItem.name, subNav: navItem },
        };

      case CODE_PAGE_DOI_NGU_LANH_DAO:
        return {
          path: navItem.linkUrl,
          loadChildren: () => import('./../../pages/about-us/leadership-team/leadership-team.module').then((m) => m.LeadershipTeamModule),
          data: { title: navItem.name, subNav: navItem },
        };

      case CODE_PAGE_QUAN_HE_CO_DONG:
        return {
          path: navItem.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () =>
                import('./../../pages/about-us/shareholder-relations/shareholder-relations.module').then(
                  (m) => m.ShareholderRelationsModule,
                ),
              data: { title: navItem.name, subNav: navItem },
            },
          ],
          data: { title: navItem.name, navItem: parentNav, subNav: navItem },
        };

      case CODE_PAGE_DOI_TAC_CUA_CHUNG_TOI:
        return {
          path: navItem.linkUrl,
          loadChildren: () => import('./../../pages/about-us/partner/partner.module').then((m) => m.PartnerModule),
          data: { title: navItem.name, subNav: navItem },
        };

      case CODE_PAGE_QUYEN_MIEN_TRU:
        return {
          path: navItem.linkUrl,
          loadChildren: () => import('./../../pages/immunities/immunities.module').then((m) => m.ImmunitiesModule),
          data: { title: navItem.name, navItem: navItem },
        };

      case CODE_PAGE_TU_VAN_DAU_TU:
        return {
          path: navItem.linkUrl,
          loadChildren: () => import('./../../pages/advisory/advisory.module').then((m) => m.AdvisoryModule),
          data: { title: navItem.name, navItem: navItem },
        };

      case CODE_PAGE_QUAN_LY_DANH_MUC_DAU_TU:
        return {
          path: navItem.linkUrl,
          loadChildren: () => import('./../../pages/portfolio/portfolio.module').then((m) => m.PortfolioModule),
          data: { title: navItem.name, navItem: navItem },
        };

      case CODE_PAGE_TRUYEN_THONG:
        return {
          path: navItem.linkUrl,
          data: { title: navItem.name, navItem },
        };

      case CODE_PAGE_TIN_TUC:
        return {
          path: navItem.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () => import('./../../pages/communication/news/news.module').then((m) => m.NewsModule),
            },
            {
              path: ':slug',
              loadChildren: () => import('./../../pages/communication/news/news-detail/news-detail.module').then((m) => m.NewsDetailModule),
            },
          ],
          data: { title: navItem.name, navItem: parentNav, subNav: navItem },
        };

      case CODE_PAGE_SU_KIEN:
        return {
          path: navItem.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () => import('./../../pages/communication/events/events.module').then((m) => m.EventsModule),
            },
            {
              path: ':slug',
              loadChildren: () =>
                import('./../../pages/communication/events/event-detail/event-detail.module').then((m) => m.EventDetailModule),
            },
          ],
          data: { title: navItem.name, navItem: parentNav, subNav: navItem },
        };

      case CODE_PAGE_THONG_CAO_BAO_CHI:
        return {
          path: navItem.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () =>
                import('./../../pages/communication/press-release/press-release.module').then((m) => m.PressReleaseModule),
            },
            {
              path: ':slug',
              loadChildren: () =>
                import('./../../pages/communication/press-release/press-release-detail/press-release-detail.module').then(
                  (m) => m.PressReleaseDetailModule,
                ),
            },
          ],
          data: { title: navItem.name, navItem: parentNav, subNav: navItem },
        };

      case CODE_PAGE_KIEN_THUC_DAU_TU:
        return {
          path: navItem.linkUrl,
          data: { title: navItem.name, navItem },
        };

      case CODE_PAGE_GOC_NHIN_DAU_TU:
        return {
          path: navItem.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () => import('./../../pages/knowledge/perspective/perspective.module').then((m) => m.PerspectiveModule),
            },
            {
              path: ':slug',
              loadChildren: () =>
                import('./../../pages/knowledge/perspective/perspective-detail/perspective-detail.module').then(
                  (m) => m.PerspectiveDetailModule,
                ),
              data: {
                title: navItem.name,
                navItem: parentNav,
                subNav: navItem,
              },
            },
          ],
          data: { title: navItem.name, navItem: parentNav, subNav: navItem },
        };

      case CODE_PAGE_CONG_CU_DAU_TU:
        return {
          path: navItem.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () => import('./../../pages/knowledge/tools/tools.module').then((m) => m.ToolsModule),
            },
          ],
          data: { title: navItem.name, navItem: parentNav, subNav: navItem },
        };

      case CODE_PAGE_KIEN_THUC_CO_BAN:
        return {
          path: navItem.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () => import('./../../pages/knowledge/basic/basic.module').then((m) => m.BasicModule),
            },
            {
              path: ':slug',
              loadChildren: () => import('./../../pages/knowledge/basic/basic-detail/basic-detail.module').then((m) => m.BasicDetailModule),
              data: {
                title: navItem.name,
                navItem: parentNav,
                subNav: navItem,
              },
            },
          ],
          data: { title: navItem.name, navItem: parentNav, subNav: navItem },
        };

      default:
        return undefined;
    }
  }

  createTree(
    navService: NavigationService,
    cateService: CategoryService,
    currentLanguage: string,
    router: Router,
    tree: {
      item: NavigationItem;
      children: {
        item: NavigationItem;
        children?: {
          item: NavigationItem;
        }[];
      }[];
    }[],
  ) {
    if (tree.length > 0) {
      const subRoutes: Routes = [];
      let defaultUrl = '';
      for (const navItem of tree) {
        const routeItem = this.genRoute(navItem.item);
        if (routeItem) {
          if (navItem.children && navItem.children.length > 0) {
            const subRouteItems: Routes = [];
            // for child navigation routing
            for (const childItem of navItem.children) {
              const childRoute = this.genRoute(childItem.item, navItem.item.slug, navItem.item);
              if (childItem.item.code === CODE_PAGE_QUAN_HE_CO_DONG) {
                const childCats = [];

                const catCongBoThongTin = cateService.getCatCongBoThongTin();
                if (childRoute && catCongBoThongTin) {
                  childCats.push({
                    path: catCongBoThongTin.linkUrl,
                    loadChildren: () =>
                      import('../../pages/about-us/shareholder-relations/information-disclosure/information-disclosure-detail/information-disclosure-detail.module').then(
                        (m) => m.InformationDisclosureDetailModule,
                      ),
                    data: {
                      title: catCongBoThongTin.name,
                      navItem: catCongBoThongTin,
                      cate: catCongBoThongTin,
                    },
                  });
                }

                const catBaoCaoDinhKy = cateService.getCatBaoCaoDinhKy();
                if (childRoute && catBaoCaoDinhKy) {
                  childCats.push({
                    path: catBaoCaoDinhKy.linkUrl,
                    loadChildren: () =>
                      import('./../../pages/about-us/shareholder-relations/periodic-reports/periodic-reports-detail/periodic-reports-detail.module').then(
                        (m) => m.PeriodicReportsDetailModule,
                      ),
                    data: {
                      title: catBaoCaoDinhKy.name,
                      navItem: catBaoCaoDinhKy,
                      cate: catBaoCaoDinhKy,
                    },
                  });
                }

                const catDaiHoiCoDong = cateService.getCatDaiHoiCoDong();
                if (childRoute && catDaiHoiCoDong) {
                  childCats.push({
                    path: catDaiHoiCoDong.linkUrl,
                    loadChildren: () =>
                      import('./../../pages/about-us/shareholder-relations/shareholders-meeting/shareholders-meeting-detail/shareholders-meeting-detail.module').then(
                        (m) => m.ShareholdersMeetingDetailModule,
                      ),
                    data: {
                      title: catDaiHoiCoDong.name,
                      navItem: catDaiHoiCoDong,
                      cate: catDaiHoiCoDong,
                    },
                  });
                }

                const catTaiLieuCongTy = cateService.getCatTaiLieuCongTy();
                if (childRoute && catTaiLieuCongTy) {
                  childCats.push({
                    path: catTaiLieuCongTy.linkUrl,
                    loadChildren: () =>
                      import('./../../pages/about-us/shareholder-relations/company-docs/company-docs-detail/company-docs-detail.module').then(
                        (m) => m.CompanyDocsDetailModule,
                      ),
                    data: {
                      title: catTaiLieuCongTy.name,
                      navItem: catTaiLieuCongTy,
                      cate: catTaiLieuCongTy,
                    },
                  });
                }

                if (childRoute && !childRoute?.children) {
                  childRoute.children = [];
                }
                if (childRoute && childRoute?.children) {
                  childRoute.children = [...childRoute.children, ...childCats];
                }
              }

              const ssChildList = navService.findChildNavs(childItem.item.code);
              if (childRoute && ssChildList.length > 0) {
                const ssRouteItems: Routes = [];
                for (const ssChild of ssChildList) {
                  const sChildRoute = this.genRoute(ssChild, navItem.item.slug, navItem.item);
                  if (sChildRoute) {
                    ssRouteItems.push(sChildRoute);
                  }
                }
                if (childRoute && !childRoute.children) {
                  childRoute.children = [];
                }
                childRoute.children = [...(childRoute.children ? childRoute.children : []), ...ssRouteItems];
              }

              if (childRoute) subRouteItems.push(childRoute);
            }
            if (!routeItem.children) {
              routeItem.children = [];
            }
            routeItem.children = [...routeItem.children, ...subRouteItems];
          }

          if (!defaultUrl) {
            defaultUrl = navItem.item.linkUrl;
            subRoutes.push({
              path: '/' + currentLanguage,
              pathMatch: 'full',
              redirectTo: '/' + currentLanguage + '/' + defaultUrl,
            });
          }

          subRoutes.push(routeItem);
        }
      }

      const termsAndConditionalNav = navService.getTermsAndConditionalNav();
      if (termsAndConditionalNav) {
        subRoutes.push({
          path: termsAndConditionalNav.linkUrl,
          loadChildren: () =>
            import('./../../pages/terms-and-conditional/terms-and-conditional.module').then((m) => m.TermsAndConditionalModule),
          data: {
            title: termsAndConditionalNav.name,
            subNav: termsAndConditionalNav,
          },
        });
      }

      const supportNav = navService.getSupportNav()?.item;
      if (supportNav) {
        const supportChildNavs = navService.findChildNavs(supportNav.code);
        const newsRoute: Route = {
          path: supportNav.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () => import('../../pages/support/support.module').then((m) => m.SupportModule),
              data: { title: supportNav.name, navItem: supportNav },
            },
          ],
          data: { title: supportNav.name, navItem: supportNav },
        };
        for (const child of supportChildNavs) {
          if (child.code === CODE_PAGE_LIEN_HE) {
            newsRoute.children?.push({
              path: child.linkUrl,
              loadChildren: () => import('../../pages/support/contact/contact.module').then((m) => m.ContactModule),
              data: {
                title: child.name,
                navItem: supportNav,
                subNav: child,
              },
            });
          }

          if (child.code === CODE_PAGE_CAU_HOI_THUONG_GAP) {
            newsRoute.children?.push({
              path: child.linkUrl,
              loadChildren: () => import('../../pages/support/faq/faq.module').then((m) => m.FaqModule),
              data: {
                title: child.name,
                navItem: supportNav,
                subNav: child,
              },
            });
          }
        }
        subRoutes.push(newsRoute);
      }

      const investNav = navService.getInvestmentFundsNav()?.item;
      if (investNav) {
        const childNavs = navService.findChildNavs(investNav.code);
        const cRoute: Route = {
          path: investNav.linkUrl,
          children: [
            {
              path: '',
              loadChildren: () => import('../../pages/investment-funds/investment-funds.module').then((m) => m.InvestmentFundsModule),
            },
          ],
          data: { title: investNav.name, navItem: investNav },
        };
        for (const child of childNavs) {
          cRoute.children?.push({
            path: child.linkUrl,
            loadChildren: () => import('../../pages/investment-funds/investment-funds.module').then((m) => m.InvestmentFundsModule),
            data: {
              title: child.name,
              navItem: investNav,
              subNav: child,
            },
          });
        }
        subRoutes.push(cRoute);
      }

      subRoutes.push(
        {
          path: 'tim-kiem',
          loadChildren: () => import('./../../pages/search/search.module').then((m) => m.SearchModule),
          data: {
            title: 'Tìm kiếm',
          },
        },
        {
          path: 'search',
          loadChildren: () => import('./../../pages/search/search.module').then((m) => m.SearchModule),
          data: {
            title: 'Search',
          },
        },
        {
          path: '404',
          loadChildren: () => import('./../../pages/page-not-found/page-not-found.module').then((m) => m.PageNotFoundModule),
        },
      );
      if (router.config[0].children) {
        router.config = [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: '/' + currentLanguage + '/' + defaultUrl,
          },
          {
            path: currentLanguage,
            pathMatch: 'full',
            redirectTo: '/' + currentLanguage + '/' + defaultUrl,
          },
          {
            path: '',
            component: MasterComponent,
            children: [{ path: currentLanguage, children: subRoutes }],
          },
          ...router.config[0].children,
          {
            path: '**',
            redirectTo: '/' + currentLanguage + '/404',
          },
        ];
      }
    }
    router.initialNavigation();
  }
}
